<ng-template [ngIf]="beneficiarioPagamento.persona?.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Cognome e Nome'" [valueInput]="beneficiarioPagamento.persona.nominativo"></div>
</ng-template>
<ng-template [ngIf]="beneficiarioPagamento.persona?.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Ragione sociale'" [valueInput]="beneficiarioPagamento.persona.nominativo"></div>
</ng-template>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Tipo beneficiario'" [valueInput]="beneficiarioPagamento.tipoBeneficiarioPagamento.label"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Titolo pagamento'" [valueInput]="element.motivo?.label"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Numero autorizzazione'" [valueInput]="element.numeroAutorizzazione"></div>
